exports.install = function (Vue, options) {
	//获取匝道出入记录
	Vue.prototype.getturnover = function(value={})
	{
		value.limitPage=this.$store.state.production.page;
		value.limitCount=this.$store.state.production.pagesize;
		value.m_qaeda_id=this.getCookie(this.config.jdid);
		return this.axiosget("/api/pt/turnover/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('turnover',response.data.data);
			}
		})
	};
}